<template>
    <div>
        <v-select 
            :class="[ { 'is-invalid bd-danger': submitForm && $v.localSelectBanking.$error } , 'w-100' ]"
            placeholder="--- กรุณาเลือกธนาคาร ---"
            label="name"
            :options="bank"
            :key="localSelectBanking"
            v-model="localSelectBanking"
            :reduce="formatBank => formatBank.code"
        ></v-select>
        <label
            v-if="submitForm && !$v.localSelectBanking.required"
            class="invalid-feedback"
            >กรุณาเลือกธนาคาร
        </label>
    </div>
    
    
</template>

<script>
import formatBank from "@/plugins/formatBank.js"
import { required } from "vuelidate/lib/validators"

export default {
    props: {
        selectBanking: String,
    },
    validations: {
        localSelectBanking: { required }
    },
    data() {
        return {
            localSelectBanking: this.selectBanking,
            bank: formatBank,
            submitForm: false
        }
    },
    methods: {
        validateSelect(){
            this.submitForm = true;
            this.$v.$touch();
            if (this.$v.$invalid ) {
                return false
            }
            this.submitForm = false;

            this.$emit('update:selectBanking', this.localSelectBanking);
        }
    }
}
</script>

<style>

</style>